import { CommonModule, } from '@angular/common';
import { Component } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';
import { ButtonModule } from 'primeng/button';

import { JOB_ROLE_MAP } from 'src/app/global.constants';

import { FreyaCommonModule } from '../../../freya-common/freya-common.module';
import { SharedModule } from '../../../shared/shared.module';
import { selectJob,  selectJobLoaded } from '../../job-tool.reducer';

import { JobAgentComponent } from './job-agent/job-agent.component';
import { OverviewChipComponent } from './overview-chip/overview-chip.component';

@Component({
  selector: 'app-overview-header',
  standalone: true,
  imports: [
    ButtonModule,
    CommonModule,
    SharedModule,
    JobAgentComponent,
    FreyaCommonModule,
    OverviewChipComponent
  ],
  templateUrl: './overview-header.component.html',
  styleUrls: [
    './overview-header.component.scss',
    '../../chips-container.scss',
  ],
})
export class OverviewHeaderComponent {

  public viewModel$ = this.store.select(createSelector({
    jobLoaded: selectJobLoaded,
    job: selectJob,
  }));

  public roles = JOB_ROLE_MAP;

  constructor(private store: Store) { }
}
